import { Experiment, Event } from "../types.ts";
import { API_ENDPOINTS, ANALYTICS } from "./constants.ts";

export function createLogger(experiment: Experiment | null) {
  return (event: Event) => {
    const eventsPayload = {
      events: [
        {
          target: ANALYTICS.WIDGET_TARGET,
          type: ANALYTICS.WIDGET_TYPE,
          version: ANALYTICS.WIDGET_VERSION,
          event: event.name,
          domain: window.location.hostname,
          path: window.location.href,
          articleId: event.articleId || "",
          testGroupId: experiment?.version || "",
          testId: experiment?.name || "",
          c1: event.articleIds?.join(",") || "",
          c2: event.postOrder?.toString() || "",
        },
      ],
    };

    const payload = JSON.stringify(eventsPayload);

    // Validate payload size
    if (payload.length > ANALYTICS.MAX_PAYLOAD_SIZE) {
      console.warn(
        `[MM Recirculation Widget] Event payload too large (${payload.length} bytes), truncating`,
        event.name
      );
      return;
    }

    console.debug(
      "[MM Recirculation Widget] Sending event -",
      event.name,
      event
    );

    // Try sendBeacon first (preferred for analytics)
    const sent = navigator.sendBeacon(API_ENDPOINTS.ANALYTICS, payload);

    if (!sent) {
      // Fallback to fetch if sendBeacon fails
      fetch(API_ENDPOINTS.ANALYTICS, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: payload,
        keepalive: true, // Keep request alive even if page is unloading
      }).catch((error) => {
        console.error(
          "[MM Recirculation Widget] Failed to send analytics event:",
          error
        );
      });
    }
  };
}
